<template>
  <section class="tw-bg-white tw-py-24">
    <div class="tw-container tw-mx-auto tw-px-6">
      <div class="tw-text-center tw-mb-16">
        <h2 class="tw-text-4xl md:tw-text-5xl tw-font-bold tw-text-gray-900 tw-mb-4 tw-leading-tight">
          What Event Organizers Say
        </h2>
      </div>

      <div class="tw-max-w-6xl tw-mx-auto">
        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-6 tw-overflow-x-auto">
          <!-- Testimonial 1 -->
          <div class="tw-bg-gray-50 tw-p-6 tw-rounded-xl tw-border tw-border-gray-100 tw-flex-shrink-0">
            <div class="tw-flex tw-items-center tw-mb-4">
              <div class="tw-w-12 tw-h-12 tw-bg-primary-100 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mr-4">
                <span class="tw-text-primary-600 tw-font-semibold tw-text-lg">A</span>
              </div>
              <div>
                <h4 class="tw-font-semibold tw-text-gray-900">Ahmed</h4>
                <p class="tw-text-sm tw-text-gray-600">GCC</p>
              </div>
            </div>
            <p class="tw-text-gray-700 tw-leading-relaxed">
              "TopEshows transformed our trade show. The matchmaking was incredible, and we saw a 3x increase in meaningful meetings."
            </p>
          </div>

          <!-- Testimonial 2 -->
          <div class="tw-bg-gray-50 tw-p-6 tw-rounded-xl tw-border tw-border-gray-100 tw-flex-shrink-0">
            <div class="tw-flex tw-items-center tw-mb-4">
              <div class="tw-w-12 tw-h-12 tw-bg-primary-100 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mr-4">
                <span class="tw-text-primary-600 tw-font-semibold tw-text-lg">M</span>
              </div>
              <div>
                <h4 class="tw-font-semibold tw-text-gray-900">Maria</h4>
                <p class="tw-text-sm tw-text-gray-600">LatAm</p>
              </div>
            </div>
            <p class="tw-text-gray-700 tw-leading-relaxed">
              "The platform is intuitive, and our sponsors were thrilled with the engagement metrics. Highly recommend!"
            </p>
          </div>

          <!-- Testimonial 3 -->
          <div class="tw-bg-gray-50 tw-p-6 tw-rounded-xl tw-border tw-border-gray-100 tw-flex-shrink-0">
            <div class="tw-flex tw-items-center tw-mb-4">
              <div class="tw-w-12 tw-h-12 tw-bg-primary-100 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mr-4">
                <span class="tw-text-primary-600 tw-font-semibold tw-text-lg">J</span>
              </div>
              <div>
                <h4 class="tw-font-semibold tw-text-gray-900">James</h4>
                <p class="tw-text-sm tw-text-gray-600">Asia</p>
              </div>
            </div>
            <p class="tw-text-gray-700 tw-leading-relaxed">
              "Best investment we made for our event. The analytics alone were worth it, but the matching quality exceeded expectations."
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
